import { Link, useLocation } from "react-router-dom";
import { usePWA } from "@/hooks/use-pwa";
import { House, Settings } from "lucide-react";

interface TabConfig {
  key: string;
  label: string;
  path: string;
  icon: typeof House | typeof Settings;
}

const TABS: TabConfig[] = [
  {
    key: "home",
    label: "홈",
    path: "/main",
    icon: House,
  },
  {
    key: "settings",
    label: "설정",
    path: "/settings",
    icon: Settings,
  },
];

// 탭바를 표시할 경로들
const TAB_VISIBLE_PATHS = ["/main", "/settings"];

/**
 * PWA 하단 탭바
 * PWA 모드에서만 표시되고, React Native 앱에서는 숨김
 */
export function BottomTabBar() {
  const { isPWA, isInApp } = usePWA();
  const location = useLocation();
  const pathname = location.pathname;

  // React Native 앱에서는 네이티브 탭바를 사용하므로 숨김
  if (isInApp) {
    return null;
  }

  // PWA가 아니면 숨김
  if (!isPWA) {
    return null;
  }

  // 특정 경로에서만 표시
  const shouldShow = TAB_VISIBLE_PATHS.some((path) =>
    pathname.startsWith(path)
  );
  if (!shouldShow) {
    return null;
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 px-4 z-40 border-t border-gray-200 bg-white shadow-2xs">
      <div className="flex">
        {TABS.map((tab) => {
          const isActive = pathname.startsWith(tab.path);
          const Icon = tab.icon;

          return (
            <Link
              key={tab.key}
              to={tab.path}
              className="flex flex-1 flex-col py-5 items-center justify-center gap-2"
            >
              <Icon
                className={`h-6 w-6 ${
                  isActive ? "text-foreground" : "text-muted"
                }`}
              />
              <span
                className={`text-xs ${
                  isActive
                    ? "font-semibold text-foreground"
                    : "font-normal text-muted"
                }`}
              >
                {tab.label}
              </span>
            </Link>
          );
        })}
      </div>
      {/* iOS Safe Area 대응 */}
      <div className="h-safe-area-inset-bottom bg-white" />
    </nav>
  );
}
